<ng-container *transloco="let t">
    <app-admin-modal-layout
            [title]="scoringDefinition?.id
      ? 'league.scoring.definition.edit'
      : 'league.scoring.definition.add'"
            [saveDisabled]="inputForm.invalid || disableEditing"
            (onSave)="onSaveButtonClick()"
            (onClose)="onClose()"
    >
      <div class="pb-4">
        <form [formGroup]="inputForm">
            <div class="row">
                <div class="col-12 col-xl-6 pb-3">
                    <app-input formControlName="name" class="mb-3" label="app.common.name" />
                </div>
                <div class="col-12 col-xl-6 pb-3">
                    <app-input type="number" formControlName="maxBasePoints" class="mb-3" label="league.scoring.max.base.points"
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-xl-6 pb-3">
                    <app-select
                            formControlName="rankingMethod"
                            [items]="rankingMethods"
                            labelKeyPrefix="league.scoring.ranking.method."
                            [valueKey]="'id'"
                            labelKey="id"
                            label="league.scoring.ranking.method"
                    />
                </div>
                <div class="col-12 col-xl-6 pb-3">
                    <app-select
                            formControlName="scoringMethod"
                            [items]="scoringMethods"
                            labelKeyPrefix="league.scoring.method."
                            [valueKey]="'id'"
                            labelKey="id"
                            label="league.scoring.method"
                    />
                </div>
            </div>
            @if (inputForm.value.scoringMethod === ScoringMethod.RELATIVE_TIME_TO_FIRST) {
            <div class="col-12 pb-3">
            <app-select
                    formControlName="measurementPrecisionType"
                    [items]="measurementPrecisionTypes"
                    labelKeyPrefix="race.settings.measurementPrecisionType."
                    [valueKey]="'id'"
                    labelKey="id"
                    label="league.scoring.measurementPrecisionType"
            />
            </div>
            }
            @if (inputForm.value.scoringMethod === ScoringMethod.POSITION_BASED) {
                <div class="pb-3" formGroupName="positionScoring">
                    <div class="py-3 d-flex justify-content-start align-items-center">
                        <div>
                            <span class="fw-bold text-uppercase fs-18">
                                {{ t('league.scoring.position.scoring') }}
                            </span>
                        </div>
                    </div>
                    <div class="row pb-3">
                        <div [ngClass]="{
                            'col-12 col-xl-12': positionScoring.value.calculationType === PositionPointsCalculationType.MANUAL,
                            'col-11 col-xl-11': positionScoring.value.calculationType === PositionPointsCalculationType.EXCEL,
                            'col-12 col-xl-5': !(positionScoring.value.calculationType === PositionPointsCalculationType.MANUAL)
                            }">
                            <app-select formControlName="calculationType"
                                        [items]="positionCalculationTypes"
                                        [labelKeyPrefix]="'league.scoring.calculation.type.'"
                                        label="league.scoring.calculation.type"/>
                        </div>

                        @if (positionScoring.value.calculationType === PositionPointsCalculationType.STEP
                        || positionScoring.value.calculationType === PositionPointsCalculationType.PERCENT) {
                        <div class="col-12 col-xl-6 d-flex">
                            <div class="col-12 col-xl-6 pb-3 pe-3">
                                <div class="d-flex align-items-top mb-3">
                                    <div class="flex-grow-1">
                                        <app-input
                                                type="number"
                                                formControlName="maxPosition"
                                                label="league.scoring.max.position"
                                        />
                                    </div>
                                    <div class="info-box">
                                        <i class="bi bi-info-circle info-icon"
                                           ngbTooltip="{{ t('league.scoring.max.position.tooltip') }}" placement="top"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-xl-6 pb-3 pe-3">
                                <div class="d-flex align-items-top mb-3">
                                    <div class="flex-grow-1">
                                        @if (positionScoring.value.calculationType === PositionPointsCalculationType.STEP) {
                                        <app-input
                                                  type="number"
                                                  formControlName="stepValue"
                                                  label="league.scoring.step.value"
                                          />
                                        }
                                        @else {
                                        <app-input
                                                   type="number"
                                                   formControlName="percentValue"
                                                   label="league.scoring.percent.value"
                                           />
                                        }
                                    </div>
                                    <div class="info-box">
                                        <i class="bi bi-info-circle info-icon"
                                           ngbTooltip=" {{  t(positionScoring.value.calculationType === PositionPointsCalculationType.STEP ?  'league.scoring.step.value.tooltip' : 'league.scoring.percent.value.tooltip')}}"
                                           placement="top">
                                        </i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }

                        @if (positionScoring.value.calculationType === PositionPointsCalculationType.STEP
                        || positionScoring.value.calculationType === PositionPointsCalculationType.PERCENT) {
                        <div class="col-1">
                            @if (!disableEditing) {
                            <div class="d-flex align-items-start justify-content-center pt-4 mt-2">
                                <app-floating-icon-button
                                        iconClass="bi bi-stars"
                                        [isDisabled]="
                            !(((positionScoring.value.calculationType === PositionPointsCalculationType.PERCENT && positionScoring.get('percentValue')?.valid)
                            || (positionScoring.get('stepValue')?.valid && positionScoring.value.calculationType === PositionPointsCalculationType.STEP))
                            && positionScoring.get('maxPosition')?.valid)"
                                        (onClick)="generatePositionScoring()"
                                />
                            </div>
                            }
                        </div>
                        }

                        @if (positionScoring.value.calculationType === PositionPointsCalculationType.EXCEL) {
                        <div class="col-1 d-flex align-items-start justify-content-center pt-3">
                          <div class="my-3">
                              <app-drag-and-drop
                                      [asButton]="true"
                                      (fileChange)="uploadExcel($event)"
                                      [fileType]="FileType.XLS"
                              />
                          </div>
                      </div>
                        }
                </div>

            @if (positions.length) {
            <div class="py-3 d-flex justify-content-between align-items-center">
                  <div class="d-flex w-100 pe-3 align-items-center">
                  @if (positionScoring.hasError('exceedsMaxPointsIndexes')) {
                    <p class="w-100">
                        <ngb-alert [dismissible]="false" type="error-info">
                            {{t('league.scoring.position.point.exceedsMaxPointsIndexes.error',
                            {value: inputForm.controls['maxBasePoints']?.value})}}
                        </ngb-alert>
                    </p>
                    }

                    @if (positionScoring.hasError('duplicatePositionIndexes')) {
                    <p class="w-100">
                        <ngb-alert [dismissible]="false" type="error-info">
                            {{t('league.scoring.position.point.duplicatePositionIndexes.error')}}
                        </ngb-alert>
                    </p>
                    }

                    @if (positionScoring.hasError('invalidStartIndexes')) {
                    <p class="w-100">
                        <ngb-alert [dismissible]="false" type="error-info">
                            {{t('league.scoring.position.point.invalidStartIndexes.error')}}
                        </ngb-alert>
                    </p>
                    }
                    </div>
                     @if (!disableEditing) {
                    <app-rounded-button
                                [label]="t('league.scoring.position.point.add')"
                                (onClick)="onAddPositionPoint()"
                                [btnClass]="'rounded-button--solid'"
                        >
                            <i class="bi bi-plus-circle pe-2"></i>
                        </app-rounded-button>
                        }
                    </div>


                    <div class="positions-holder">
                    @for (pos of positions.controls; track pos; let index = $index; let last = $last) {
            <div formArrayName="positions">
              <div [formGroupName]="index">
                <div class="row pt-2">
                  <div class="col-4">
                    <app-input
                      type="number"
                      label="league.scoring.position.point.position"
                      formControlName="position"
                      [displayParentError]="((positionScoring.errors?.['duplicatePositionIndexes']?.includes(index) || positionScoring.errors?.['invalidStartIndexes']?.includes(index)) || false)"
                    />
                  </div>

                  <div class="col-7">
                    <app-input
                      type="number"
                      label="league.scoring.position.point.points"
                      formControlName="points"
                      [displayParentError]="(positionScoring.errors?.['exceedsMaxPointsIndexes']?.includes(index) || false)"
                    />
                  </div>

                  <div class="col-1 d-flex align-items-start justify-content-center pt-4 mt-2">
                     @if (!disableEditing) {
                    <app-floating-icon-button
                      iconClass="bi bi-trash-fill"
                      (onClick)="onDeleteBonusPoint(index)"
                    />
                    }
                  </div>
                </div>
              </div>
            </div>
            }
            </div>
            }
            </div>
             }
        </form>
      </div>
    </app-admin-modal-layout>
</ng-container>
